/* import __COLOCATED_TEMPLATE__ from './user-profile-avatar.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
